var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13360_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.68225 5.14037L8.6175 0.98237C8.73406 0.912432 8.86744 0.875488 9.00338 0.875488C9.13931 0.875488 9.27269 0.912432 9.38925 0.98237L16.3177 5.14112C16.3733 5.17443 16.4194 5.22158 16.4513 5.27797C16.4832 5.33436 16.5 5.39806 16.5 5.46287V14.9999C16.5 15.1988 16.421 15.3895 16.2803 15.5302C16.1397 15.6709 15.9489 15.7499 15.75 15.7499H2.25C2.05109 15.7499 1.86032 15.6709 1.71967 15.5302C1.57902 15.3895 1.5 15.1988 1.5 14.9999V5.46212C1.49999 5.39731 1.51677 5.33361 1.54871 5.27722C1.58065 5.22083 1.62666 5.17368 1.68225 5.14037ZM13.7595 6.18287L9.04575 10.2621L4.23525 6.17837L3.26475 7.32137L9.05475 12.2376L14.7405 7.31762L13.7595 6.18287Z",
    fill: "#7E00FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13360_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8b638fb6c6dab5011c03363347c533ac.svg";
export { ForwardRef as ReactComponent };